/**
 * cn — join class names, dropping anything falsy.
 *
 *   cn("tw-flex", isOpen && "tw-hidden", className)
 *
 * ⚠️ This does NOT resolve conflicting Tailwind utilities the way
 * `tailwind-merge` does. `cn("tw-p-2", "tw-p-4")` emits both classes and the
 * winner is decided by their order in the compiled stylesheet, not by their
 * order here. So a primitive that lets a prop override its own default must not
 * emit that default in the first place — resolve `size` and `variant` to exactly
 * one class each, never layer them.
 */
const cn = (...parts) => parts.filter(Boolean).join(" ");

export default cn;
